import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';
import authReducer from '../../features/Auth/slice';
import alertReducer from '../../features/Alert/slice';
import accountReducer from "../../features/Passport/AccountInfo/api/slice"
import securityReducer from "../../features/Passport/Security/api/slice"
import educationReducer from "../../features/Passport/Education/api/slice"
import careerReducer from "../../features/Passport/Career/api/slice"
import userReducer from '../../features/Passport/AccountInfo/UserInfo/slice'
import phoneConfirmReducer from "../../features/Auth/Steps/Phone/slice"
export const store = configureStore({
    reducer: {
        alert: alertReducer,
        auth: authReducer,
        account: accountReducer,
        security: securityReducer,
        education: educationReducer,
        career: careerReducer,
        user: userReducer,
        phoneConfirm: phoneConfirmReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [],
                // Ignore these field paths in all actions
                // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
                // Ignore these paths in the state
                ignoredPaths: ['account.personalInfo.birthdate', 'account.passport.issued_at', "account.foreign_passport.issued_at", "account.foreign_passport.expires_at", "account.foreign_passport.outdated", "account.passport.outdated"],
            },
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>;
